import _ from 'lodash';
import { BookingStatus, TravelTypes } from '../constants';
import { checkIsBookingResponseFailed } from './checkIsTripBookingFailed';

// A cancelled or failed car booking has no booked rate, so its price change is not shown.
// A price change without both prices has nothing to compare, so it is skipped too.
const getCarPriceChangesAtBooking = (tripConfirmation) => {
  const tripSegments = tripConfirmation?.trip?.tripSegments;
  if (!tripSegments) return [];

  return tripSegments.reduce((priceChanges, tripSegment) => {
    const priceChange = tripSegment.itinerary?.priceInfo?.priceChangeAtBooking;
    if (
      tripSegment.mode !== TravelTypes.carrental ||
      typeof priceChange?.quotedPrice !== 'number' ||
      typeof priceChange.bookedPrice !== 'number'
    ) {
      return priceChanges;
    }
    const bookingResponse = _.find(
      tripConfirmation.bookingResponses,
      (b) => b.tripSegmentId === tripSegment.id,
    );
    if (
      !bookingResponse ||
      bookingResponse.bookingStatus === BookingStatus.cancelled ||
      checkIsBookingResponseFailed(bookingResponse)
    ) {
      return priceChanges;
    }

    priceChanges.push({
      ...priceChange,
      tripSegmentId: tripSegment.id,
      bookingReference: bookingResponse.bookingReference,
      // Same rule as the Cancel button of the booked car on the confirmation page
      isCancellable:
        !!bookingResponse.bookingStatus && bookingResponse.bookingStatus !== BookingStatus.pending,
    });
    return priceChanges;
  }, []);
};

// A rebooked car (Change Car) gets a new booking reference, so the same prices still count as new
const getPriceChangeKey = (priceChange) =>
  [
    priceChange.tripSegmentId,
    priceChange.bookingReference,
    priceChange.quotedPrice,
    priceChange.bookedPrice,
  ].join('|');

// Price changes the latest booking produced, the ones the previous confirmation of the same trip
// already had were acknowledged before (or belong to an earlier booking)
export const getNewCarPriceChangesAtBooking = (previousTripConfirmation, tripConfirmation) => {
  if (!tripConfirmation) return null;

  const previousKeys =
    previousTripConfirmation?.tripId === tripConfirmation.tripId
      ? getCarPriceChangesAtBooking(previousTripConfirmation).map(getPriceChangeKey)
      : [];
  const priceChanges = getCarPriceChangesAtBooking(tripConfirmation).filter(
    (priceChange) => !previousKeys.includes(getPriceChangeKey(priceChange)),
  );

  return priceChanges.length ? { tripId: tripConfirmation.tripId, priceChanges } : null;
};

export default getCarPriceChangesAtBooking;
